import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const formContainerStyles = css`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

export const previewTitleStyles = (theme: Theme, hasValue: boolean) => css`
  font-size: 1rem;
  color: ${hasValue ? '#101010' : theme.palette.text.disabled};
  padding-top: 4px;
  font-weight: 600;
  line-height: 1.5rem;
  display: flex;
  align-items: flex-end;
  ${!hasValue && 'font-style: italic;'}
`

export const previewDescriptionStyles = (theme: Theme, hasValue: boolean) => css`
  padding-bottom: 8px;
  overflow-wrap: break-word;
  ${!hasValue && `color: ${theme.palette.text.disabled}; font-style: italic;`}
`
